// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewHistory-InfoIcon_cls1__P5Yer","cls2":"PaymentViewHistory-InfoIcon_cls2__VtTnu PaymentViewHistory-InfoIcon_cls1__P5Yer"};